import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withUserType } from '../withUserType';
import { Form } from '@ant-design/compatible';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWRadio from '../static_visual_radio_input/StaticVisualRadioInput';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	walkthroughsRestCrudThunksForBuyer,
	walkthroughsRestCrudThunksForSupplier,
} from '../../thunks/walkthroughs_thunks';
import { message } from 'antd';
import { SITE_SURVEY_ANSWER_TYPE } from '../../utils/SiteSurveyUtils';
import WalkthroughTaskListAnswerDisplay from '../walkthroughs_detail_details_page/WalkthroughTaskListAnswerDisplay';
import { getPendingUnlinkedTaskItems } from '../../utils/TaskItemUtils';

require('./NewWorkOrderWizardPage.less');

const WOTaskListStep: FC<any> = ({
	getCurrentState,
	formData,
	goNextMethod,
	setState,
	form,

	getWalkthrough,
}) => {
	const { getFieldDecorator } = form;

	const [walkthroughLoading, setWalkthroughLoading] = useState(true);
	const [taskAnswer, setTaskAnswer] = useState([]);

	const state = useMemo(() => getCurrentState(), [getCurrentState]);

	const { walkthroughId, siteSurveyTaskTitleId } = state;

	useEffect(() => {
		if (walkthroughId && siteSurveyTaskTitleId) {
			getWalkthrough(walkthroughId)
				.then((walkthrough) => {
					const answerForTitle = nullSafeGetOrElse('taskAnswers', walkthrough, []).find(
						(_) => _.titleId === siteSurveyTaskTitleId
					);
					if (
						answerForTitle.questionType === SITE_SURVEY_ANSWER_TYPE.TASK_LIST &&
						getPendingUnlinkedTaskItems(answerForTitle).length > 0
					) {
						setTaskAnswer(answerForTitle);
					} else {
						goNextMethod();
					}
				})
				.catch((err) => {
					message.error(err);
					goNextMethod();
				})
				.finally(() => setWalkthroughLoading(false));
		}
	}, []);

	const handleIncludeTaskChange = useCallback(
		(val) => {
			setState(
				{
					includeWalkthroughTaskList: val === 'true',
					taskAnswer,
				},
				() => {
					goNextMethod();
				}
			);
		},
		[goNextMethod, setState, taskAnswer]
	);

	return walkthroughLoading || !nullSafeGet('taskListAnswer', taskAnswer) ? (
		<PageLoadingPlaceholder />
	) : (
		<div key={8} className="newWorkOrderWizardPage__section">
			<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
				{`Include the following tasks to this work order?`}
			</h3>
			<Form.Item style={{ width: '100%' }}>
				{getFieldDecorator(`includeWalkthroughTaskList`, {
					initialValue: nullSafeGetOrElse('includeWalkthroughTaskList', formData, ''),
				})(
					<OWRadio
						fieldName="includeWalkthroughTaskList"
						onChange={handleIncludeTaskChange}
						onClick={handleIncludeTaskChange}
						renderRecord={(opt) => opt.name}
						records={{
							true: {
								id: 'true',
								name: 'Include Tasks',
							},
							false: {
								id: 'false',
								name: 'Exclude Tasks',
							},
						}}
						sorter={(records) => records.sort((a, b) => (a.id < b.id ? 1 : -1))}
					/>
				)}
				<WalkthroughTaskListAnswerDisplay
					taskAnswer={taskAnswer}
					withTitle
					hideDisabledHelper
					includeOnlyPendingTaskItems
					includeHelpText
				/>
			</Form.Item>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	locations: state.locations,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWalkthrough: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? walkthroughsRestCrudThunksForSupplier.readOne(id)
				: walkthroughsRestCrudThunksForBuyer.readOne(id)
		),
});

export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(WOTaskListStep as any) as any
);
